module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/6_36e5ff3b9c228855bbe26019e99ba77f.jpg";